import api from 'api/axiosInstance';
import type { Paging } from 'types/pagination.types';

export type BeneficiaryContactType = {
  created: string;
  modified: string;
  iban: string;
  bic?: string;
  isVerified?: boolean;
  name: string;
  userId: string;
  __v: number;
  _id: string;
};

interface ContactListPayload {
  iban?: string;
  name?: string;
}
interface ContactListResponse {
  items: BeneficiaryContactType[];
  paging: Paging;
}
const getContactList = (
  params: ContactListPayload,
): Promise<ContactListResponse> =>
  api
    .get<any, ContactListResponse>(
      '/v2/accountable-banking/search-beneficiaries',
      { params },
    )
    .then((data) => ({
      ...data,
      data: data.items,
    }));

export default getContactList;
